const STORAGE_KEY = 'dd_pending_checkout';
const MAX_AGE_MS = 72 * 60 * 60 * 1000;

const canUseStorage = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const rememberPendingCheckout = (plan) => {
  if (!canUseStorage() || !plan) return;
  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      plan: String(plan).trim().toLowerCase(),
      startedAt: Date.now(),
    })
  );
};

export const clearPendingCheckout = () => {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(STORAGE_KEY);
};

export const getPendingCheckout = () => {
  if (!canUseStorage()) return null;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const plan = String(parsed?.plan || '').trim().toLowerCase();
    const startedAt = Number(parsed?.startedAt || 0);
    if (!plan || !startedAt || Date.now() - startedAt > MAX_AGE_MS) {
      clearPendingCheckout();
      return null;
    }
    return { plan, startedAt };
  } catch {
    clearPendingCheckout();
    return null;
  }
};
